if (!customElements.get('pdp-product-tabs')) {
  class PdpProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-pdp-tab]');
      this.panels = this.querySelectorAll('[data-pdp-panel]');

      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const clickedTab = event.target.closest('[data-pdp-tab]');
      if (!clickedTab) return;

      const targetPanelId = clickedTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === clickedTab;
        tab.classList.toggle('pdp-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === targetPanelId;
        panel.classList.toggle('pdp-tabs__panel--active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    }
  }

  customElements.define('pdp-product-tabs', PdpProductTabs);
}
